import React from 'react';

import Dashboard from 'ui/dashboard/Dashboard';
import ConnectorDashboardBox from './types/common/DashboardBox';
import { accessEnvironment } from 'utils/system';
import { ServiceStatus } from './consts';
import { getServiceStatus } from './utils';

export default ({
    extra: { services, configs, onSelect, editable, settings },
}) => (
    <Dashboard columns={3}>
        {parepareDashboards(services, configs, onSelect, editable, settings)}
    </Dashboard>
);

function parepareDashboards(
    services,
    configs,
    onSelect,
    editable,
    { environment }
) {
    return configs
        .filter(
            config =>
                config.visible && accessEnvironment(config.envs, environment)
        )
        .map(config => {
            const { name, label, enabled, logo } = config;
            const service = services.find(
                service => service.identifier === config.name
            );
            const status = getServiceStatus(config, service);
            return (
                <ConnectorDashboardBox
                    key={name}
                    label={label}
                    logo={logo}
                    status={status}
                    isEnabled={enabled}
                    onSelect={() => {
                        const isActive = !!(status & ServiceStatus.ACTIVE);
                        if (!isActive && !editable && !config.alwaysVisible) {
                            return;
                        }
                        onSelect(config);
                    }}
                />
            );
        });
}
